import React, { useRef } from 'react';
import f from '../../helpers/formatter';
import { FlexWrapper, RemindItem, Text } from '@intigral/shared';
import { Carousel2 } from '@intigral/ui';
import useToggleDetailOverlay from '../../hooks/useToggleDetailOverlay';
import { useDispatch } from 'react-redux';
import { showUpgradedModal } from '../../store/reducers/generalConfigurationSlice';

interface Languages {
    ar?: string;
    en?: string;
}
interface PPVCarouselProps {
    carousel: any;
    content: any[];
    language: string;
    name?: string;
    meta?: {
        title?: Languages;
    };
    fetchNextPage?: () => void;
    hasNextPage?: boolean;
}

export const PPVReminderCarousel: React.FC<PPVCarouselProps> = ({
    carousel,
    meta,
    language,
    content,
    hasNextPage,
    fetchNextPage,
}) => {
    const ppvSwiperElement = useRef(null);
    const { showPpvOverlay } = useToggleDetailOverlay();
    const dispatch = useDispatch();

    const onLockClick = (_item) => {
        dispatch(showUpgradedModal(true));
    };

    return (
        <div id="reminder-carousel" className="container full-width" data-test-id={carousel?.id}>
            <FlexWrapper gap="2x" justifyContent="between">
                <Text
                    as="h2"
                    variant="h2"
                    alignment="start"
                    margin={{ default: '2x', md: '3x' }}
                    size={{ default: '18', md: '28' }}
                >
                    {meta && f.getComponentTitle(meta)}
                </Text>
            </FlexWrapper>
            <Carousel2
                ref={ppvSwiperElement}
                swiperSettings={{
                    slidesPerView: 1,
                    breakpoints: {
                        560: {
                            slidesPerView: 2,
                        },
                        824: {
                            slidesPerView: 3,
                        },
                        1212: {
                            slidesPerView: 4,
                        },
                        1500: {
                            slidesPerView: 5,
                        },
                    },
                }}
                reachEnd={() => {
                    if (hasNextPage) fetchNextPage();
                }}
            >
                {content.map((item) => {
                    return (
                        <RemindItem
                            key={item.Id}
                            href={''}
                            image={item.mainImage?.src}
                            title={item.title}
                            description={item.description}
                            when={item.timeStamp}
                            showBell={item.showBellIcon}
                            locked={item.isLocked}
                            onClick={(e) => {
                                if (item.isLocked) {
                                    e.preventDefault();
                                    onLockClick?.(item);
                                }
                                // else if (item?.ppvEventId) {
                                //     showPpvOverlay({
                                //         eventId: item.ppvEventId
                                //     })
                                // }
                            }}
                        />
                    );
                })}
            </Carousel2>
        </div>
    );
};
